var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('direction-light',{attrs:{"position":_vm.sun,"hex":_vm.hex,"intensity":_vm.intensity}})}
var staticRenderFns = []

export { render, staticRenderFns }